import { Ability } from "@casl/ability";

export const ability = new Ability();

export const abilityPlugin = (store) => {
  ability.update(store.state.rules);

  return store.subscribe((mutation) => {
    // console.log(mutation)
    switch (mutation.type) {
      case "loginSuccess":
        let formattedRules = [];

        if (mutation.payload.userinfo.Roles.length > 0) {
          formattedRules = mutation.payload.userinfo.Roles.map((perm) => {
            let formattedObj = {};
            formattedObj.actions = perm;
            formattedObj.subject = "permissions";
            return formattedObj;
          });
        }
        ability.update(formattedRules);
        break;
      case "logoutSuccess":
        ability.update([{ actions: "read", subject: "all" }]);
        break;
    }
  });
};
